import React from "react";
import "./Signup.css";
import { SignupPostConfirm } from "./SignupPostConfirm.js";
import FadeIn from "react-fade-in";

export class SignupConfirm extends React.Component {
  constructor(props) {
    super(props);

    this.goToConfirm = this.goToConfirm.bind(this);
    this.confirmed = this.confirmed.bind(this);
    this.checkSeatData = this.checkSeatData.bind(this);

    this.state = {
      confirmed: false,
      vippsnummer: 64923,
      code: "",
      rows: {},
      lockConfirm: true
    };
  }

  componentDidMount() {
    this.checkSeatData();
  }

  //We verify that the clientside has the same seats as the backend
  checkSeatData() {
    let myHeaders = new Headers();
    myHeaders.append("pragma", "no-cache");
    myHeaders.append("cache-control", "no-cache");

    let myInit = {
      method: "GET",
      headers: myHeaders
    };

    fetch("/api/seating/checkseats/" + this.props.guid, myInit)
      .then(function(response) {
        return response.json();
      })
      .then(rowdata => {
        this.setState({ rows: rowdata });
      })
      .catch(error => console.error("Error:", error))
      .then(() => {
        if (this.state.rows.length === this.props.selectedSeatObjs.length) {
          for (let i = 0; i < this.state.rows.length; i++) {
            if (
              !this.props.selectedSeatObjs[i].reserver ===
                this.state.rows[i].reserver &&
              !this.props.selectedSeatObjs[i].rownum ===
                this.state.rows[i].rownum &&
              !this.props.selectedSeatObjs[i].number ===
                this.state.rows[i].number
            ) {
              //Failstate
              alert("Noe gikk galt, vennligst prøv igjen!");
              this.props.goBack();
            }
          }
        } else {
          //Failstate
          alert("Noe gikk galt, vennligst prøv igjen!");
          this.props.goBack();
          return;
        }
        //SUCCESS
        this.setState({ lockConfirm: false });
      });
  }

  goToConfirm(e) {
    this.props.goToConfirm(e);
  }

  confirmed(e) {
    e.preventDefault();

    //Confirm dialog
    let response = window.confirm(
      "Du bekrefter herved bestillingen. Betalingsinformasjon vil vises på neste side"
    );

    if (response === false) {
      return;
    }

    this.setState({ code: this.props.guid.slice(-6) });

    this.props.SetTimes(0, 0, 0);

    let selectedSeats = [];
    for (let i = 0; i < this.props.selectedSeatObjs.length; i++) {
      selectedSeats.push(this.props.selectedSeatObjs[i]);
      selectedSeats[i].reserver = this.props.guid.slice(-6);
    }

    const orderInfo = [];
    orderInfo.push(selectedSeats);

    if (
      this.props.p1.firstName !== "" &&
      this.props.p1.lastName !== "" &&
      this.props.p1.age !== "" &&
      this.props.p1.email !== "" &&
      this.props.setNumPersons >= 1
    ) {
      orderInfo.push(this.props.p1);
      orderInfo[1].rowNum = this.props.selectedSeatObjs[0].rownum;
      orderInfo[1].seatNum = this.props.selectedSeatObjs[0].number;
      orderInfo[1].guid = this.props.guid;
      orderInfo[1].code = this.props.guid.slice(-6);
      orderInfo[1].foodTicketDisabled = this.props.foodTicketDisabled;
    }

    if (
      this.props.p2.firstName !== "" &&
      this.props.p2.lastName !== "" &&
      this.props.p2.age !== "" &&
      this.props.p2.email !== "" &&
      this.props.setNumPersons >= 2
    ) {
      orderInfo.push(this.props.p2);
      orderInfo[2].rowNum = this.props.selectedSeatObjs[1].rownum;
      orderInfo[2].seatNum = this.props.selectedSeatObjs[1].number;
      orderInfo[2].guid = this.props.guid;
      orderInfo[2].code = this.props.guid.slice(-6);
      orderInfo[1].foodTicketDisabled = this.props.foodTicketDisabled;
    }

    if (
      this.props.p3.firstName !== "" &&
      this.props.p3.lastName !== "" &&
      this.props.p3.age !== "" &&
      this.props.p3.email !== "" &&
      this.props.setNumPersons >= 3
    ) {
      orderInfo.push(this.props.p3);
      orderInfo[3].rowNum = this.props.selectedSeatObjs[2].rownum;
      orderInfo[3].seatNum = this.props.selectedSeatObjs[2].number;
      orderInfo[3].guid = this.props.guid;
      orderInfo[3].code = this.props.guid.slice(-6);
      orderInfo[1].foodTicketDisabled = this.props.foodTicketDisabled;
    }

    if (
      this.props.p4.firstName !== "" &&
      this.props.p4.lastName !== "" &&
      this.props.p4.age !== "" &&
      this.props.p4.email !== "" &&
      this.props.setNumPersons >= 4
    ) {
      orderInfo.push(this.props.p4);
      orderInfo[4].rowNum = this.props.selectedSeatObjs[3].rownum;
      orderInfo[4].seatNum = this.props.selectedSeatObjs[3].number;
      orderInfo[4].guid = this.props.guid;
      orderInfo[4].code = this.props.guid.slice(-6);
      orderInfo[1].foodTicketDisabled = this.props.foodTicketDisabled;
    }

    if (
      this.props.p5.firstName !== "" &&
      this.props.p5.lastName !== "" &&
      this.props.p5.age !== "" &&
      this.props.p5.email !== "" &&
      this.props.setNumPersons >= 5
    ) {
      orderInfo.push(this.props.p5);
      orderInfo[5].rowNum = this.props.selectedSeatObjs[4].rownum;
      orderInfo[5].seatNum = this.props.selectedSeatObjs[4].number;
      orderInfo[5].guid = this.props.guid;
      orderInfo[5].code = this.props.guid.slice(-6);
      orderInfo[1].foodTicketDisabled = this.props.foodTicketDisabled;
    }
    orderInfo.push(this.props.tooYoung);

    //Post/put to backend and refresh again
    fetch("/api/seating/submit/" + this.props.guid, {
      method: "PUT",
      body: JSON.stringify(orderInfo),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }).then(response => {
      if (response.status === 200) {
      } else {
        alert("Noe gikk galt med din påmelding. Vennligst prøv igjen");
        this.props.goBack();
      }
    });

    fetch("/api/signupemailer/sendmail/" + this.props.guid, {
      method: "PUT",
      body: JSON.stringify(orderInfo),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }).then(response => {
      if (response.status === 200) {
        this.setState({ confirmed: true });
      } else {
        alert("Noe gikk galt med din påmelding. Vennligst prøv igjen");
        this.props.goBack();
      }
    });
  }

  render() {
    let personArr = [];

    personArr.push();

    if (
      this.props.p1 !== null &&
      this.props.p1.firstName !== "" &&
      this.props.p1.lastName !== "" &&
      this.props.p1.phone !== "" &&
      this.props.setNumPersons >= 1 &&
      this.props.selectedSeatObjs[0] !== undefined
    ) {
      personArr.push(
        <div key={1} className="col-sm summaryCard">
          <h6>Deltaker 1</h6>
          <h6>
            {" "}
            Navn: {this.props.p1.firstName} {this.props.p1.lastName}{" "}
          </h6>
          <h6>Alder: {this.props.p1.age} </h6>
          {this.props.foodTicketDisabled && (
            <h6>Matbillett: {this.props.p1.foodTicket ? "Ja" : "Nei"}</h6>
          )}
          <h6>Mobil: {this.props.p1.phone} </h6>
          <h6>Epost: {this.props.p1.email} </h6>
          <h6>
            Rad {this.props.selectedSeatObjs[0].rownum} Plass{" "}
            {this.props.selectedSeatObjs[0].number}
          </h6>
          <h6>Spesielle behov: {this.props.p1.special} </h6>
        </div>
      );
    }

    if (
      this.props.p2 !== null &&
      this.props.p2.firstName !== "" &&
      this.props.p2.lastName !== "" &&
      this.props.p2.phone !== "" &&
      this.props.setNumPersons >= 2
    ) {
      personArr.push(
        <div key={2} className="col-sm summaryCard">
          <h6>Deltaker 2</h6>
          <h6>
            {" "}
            Navn: {this.props.p2.firstName} {this.props.p2.lastName}{" "}
          </h6>
          <h6>Alder: {this.props.p2.age} </h6>
          {this.props.foodTicketDisabled && (
            <h6>Matbillett: {this.props.p2.foodTicket ? "Ja" : "Nei"}</h6>
          )}
          <h6>Mobil: {this.props.p2.phone} </h6>
          <h6>Epost: {this.props.p2.email} </h6>
          <h6>
            Rad {this.props.selectedSeatObjs[1].rownum} Plass{" "}
            {this.props.selectedSeatObjs[1].number}
          </h6>
          <h6>Spesielle behov: {this.props.p2.special} </h6>
        </div>
      );
    }

    if (
      this.props.p3 !== null &&
      this.props.p3.firstName !== "" &&
      this.props.p3.lastName !== "" &&
      this.props.p3.phone !== "" &&
      this.props.setNumPersons >= 3
    ) {
      personArr.push(
        <div key={3} className="col-sm summaryCard">
          <h6>Deltaker 3</h6>
          <h6>
            {" "}
            Navn: {this.props.p3.firstName} {this.props.p3.lastName}{" "}
          </h6>
          <h6>Alder: {this.props.p3.age} </h6>
          {this.props.foodTicketDisabled && (
            <h6>Matbillett: {this.props.p3.foodTicket ? "Ja" : "Nei"}</h6>
          )}
          <h6>Mobil: {this.props.p3.phone} </h6>
          <h6>Epost: {this.props.p3.email} </h6>
          <h6>
            Rad {this.props.selectedSeatObjs[2].rownum} Plass{" "}
            {this.props.selectedSeatObjs[2].number}
          </h6>
          <h6>Spesielle behov: {this.props.p3.special} </h6>
        </div>
      );
    }

    if (
      this.props.p4 !== null &&
      this.props.p4.firstName !== "" &&
      this.props.p4.lastName !== "" &&
      this.props.p4.phone !== "" &&
      this.props.setNumPersons >= 4
    ) {
      personArr.push(
        <div key={4} className="col-sm summaryCard">
          <h6>Deltaker 4</h6>
          <h6>
            {" "}
            Navn: {this.props.p4.firstName} {this.props.p4.lastName}{" "}
          </h6>
          <h6>Alder: {this.props.p4.age} </h6>
          {this.props.foodTicketDisabled && (
            <h6>Matbillett: {this.props.p4.foodTicket ? "Ja" : "Nei"}</h6>
          )}
          <h6>Mobil: {this.props.p4.phone} </h6>
          <h6>Epost: {this.props.p4.email} </h6>
          <h6>
            Rad {this.props.selectedSeatObjs[3].rownum} Plass{" "}
            {this.props.selectedSeatObjs[3].number}
          </h6>
          <h6>Spesielle behov: {this.props.p4.special} </h6>
        </div>
      );
    }

    if (
      this.props.p5 !== null &&
      this.props.p5.firstName !== "" &&
      this.props.p5.lastName !== "" &&
      this.props.p5.phone !== "" &&
      this.props.setNumPersons >= 5
    ) {
      personArr.push(
        <div key={5} className="col-sm summaryCard">
          <h6>Deltaker 5</h6>
          <h6>
            {" "}
            Navn: {this.props.p5.firstName} {this.props.p5.lastName}{" "}
          </h6>
          <h6>Alder: {this.props.p5.age} </h6>
          {this.props.foodTicketDisabled && (
            <h6>Matbillett: {this.props.p5.foodTicket ? "Ja" : "Nei"}</h6>
          )}
          <h6>Mobil: {this.props.p5.phone} </h6>
          <h6>Epost: {this.props.p5.email} </h6>
          <h6>
            Rad {this.props.selectedSeatObjs[4].rownum} Plass{" "}
            {this.props.selectedSeatObjs[4].number}
          </h6>
          <h6>Spesielle behov: {this.props.p5.special} </h6>
        </div>
      );
    }

    const price = (
      <h3 className="col-sm priceCard">
        {" "}
        Å betale: {this.props.totalPrice},-{" "}
      </h3>
    );

    return (
      <FadeIn>
        <div>
          {this.state.confirmed === false && (
            <div>
              <h2>Oppsummering</h2>
              <div>
                <div>
                  <div className="col-center">{personArr}</div>

                  <div className="col-center summaryCard">
                    <h5>Ved å trykke på "Bekreft"</h5>
                    <p>
                      Godtar du reservasjon av plassene. <br /> Du verifiserer
                      at informasjonen er korrekt. <br />
                      Du godtar kjøps og salgsbetingelsene du finner <a target='_blank' href={window.origin + '/betingelser'}>her</a> <br/>
                      På neste side vil du få betalingsinformasjon for å betale
                      med Vipps. <br />
                      Vi tilbyr ingen annen betalingsform enn Vipps for
                      øyeblikket. <br />{" "}
                    </p>
                    <p>
                      Du vil få en bekreftelse på mail med informasjon om din
                      reservasjon.
                    </p>
                  </div>
                  {price}

                  <div>
                    <h4> Tid igjen: </h4>
                    {this.props.timeLeft}
                    <p> </p>
                  </div>

                  <button
                    className="btn btno btn-danger help"
                    onClick={this.props.goBack}
                  >
                    {" "}
                    Tilbake{" "}
                  </button>

                  {this.state.lockConfirm === false && (
                    <button
                      className="btn btno btn-info help"
                      onClick={this.confirmed}
                    >
                      {" "}
                      Bekreft reservasjon{" "}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {this.state.confirmed === true && (
            <SignupPostConfirm
              vippsnummer={this.state.vippsnummer}
              code={this.state.code}
              tooYoung={this.props.tooYoung}
              totalPrice={this.props.totalPrice}
              foodTicketDisabled={this.props.foodTicket}
            />
          )}
        </div>
      </FadeIn>
    );
  }
}

export default SignupConfirm;



// WEBPACK FOOTER //
// ./src/Components/Signup/SignupConfirm.js